// extracted by mini-css-extract-plugin
export default {"PostPreviewWrapper":"PostPreview_PostPreviewWrapper__9oA1m"};